// extracted by mini-css-extract-plugin
module.exports = {"style":"_2Z5kL9_qtaLw6M541k5gEv"};